var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Component from "../lib/component";
import html from "./leftMenu.html";
import KnockoutModel from "../lib/knockout_model";
import * as ajax from '../app-lib/ajax_proxy';
import page from 'page';
import "./leftMenu.scss";
import { Topics } from "../app-lib/constants";
import * as authorization from "../lib/authorization";
import schedule from "../assets/js/schedule.js";
var Schedule = schedule;
var LeftMenuModel = /** @class */ (function (_super) {
    __extends(LeftMenuModel, _super);
    function LeftMenuModel(root) {
        var _this = _super.call(this, '/api/type/side', root, {}) || this;
        _this.myProject = ko.observable(); //我的项目 消息提示
        _this.myFollowProject = ko.observable(); //我关注的项目 消息提示
        _this.noFollowNews = ko.observable(); //未关注的项目 消息提示
        _this.waitProjectNews = ko.observable(); //签约等待确认项目 消息提示
        _this.signgedProjectNews = ko.observable(); //已签约的项目 消息提示
        _this.abandonProjectNews = ko.observable(); //已放弃的项目 消息提示
        _this.auditMessage = ko.observable(); //审核消息
        _this.username = ko.observable();
        _this.role = ko.observable();
        _this.imgurl = ko.observable();
        _this.allProject = ko.observable(); //我的项目
        _this.followProject = ko.observable(); //我关注的项目
        _this.nofollow = ko.observable(); //未跟进的项目
        _this.waitProject = ko.observable(); //签约等待确认项目
        _this.signgedProject = ko.observable(); //已签约的项目
        _this.abandonProject = ko.observable(); //已放弃的项目
        _this.noReadProject = ko.observable(); //项目消息
        _this.nowDay = ko.observable(); //当天
        _this.nowMonth = ko.observable(); //当月
        _this.nowYear = ko.observable(); //当年
        _this.nowDayTipList = ko.observableArray([]); //今日提醒
        _this.showTB = ko.observable(false);
        _this.monthDataList = ko.observableArray([]); //
        //消息提醒
        ko.postbox.subscribe("leftMenu_myProject", function (n) { return _this.myProject(n); });
        ko.postbox.subscribe("leftMenu_myFollowProject", function (n) { return _this.myFollowProject(n); });
        ko.postbox.subscribe("leftMenu_noFollowNews", function (n) { return _this.noFollowNews(n); });
        ko.postbox.subscribe("leftMenu_waitProjectNews", function (n) { return _this.waitProjectNews(n); });
        ko.postbox.subscribe("leftMenu_signgedProjectNews", function (n) { return _this.signgedProjectNews(n); });
        ko.postbox.subscribe("leftMenu_abandonProjectNews", function (n) { return _this.abandonProjectNews(n); });
        //审核消息
        ko.postbox.subscribe('leftMenu_auditMessage', function (n) { return _this.auditMessage(n); });
        //项目数量
        ko.postbox.subscribe('leftMenu_allProject', function (n) { return _this.allProject(n); });
        ko.postbox.subscribe('leftMenu_followProject', function (n) { return _this.followProject(n); });
        ko.postbox.subscribe('leftMenu_nofollow', function (n) { return _this.nofollow(n); });
        ko.postbox.subscribe('leftMenu_waitProject', function (n) { return _this.waitProject(n); });
        ko.postbox.subscribe('leftMenu_signgedProject', function (n) { return _this.signgedProject(n); });
        ko.postbox.subscribe('leftMenu_abandonProject', function (n) { return _this.abandonProject(n); });
        ko.postbox.subscribe('leftMenu_noReadProject', function (n) { return _this.noReadProject(n); });
        ko.postbox.subscribe('reshLeft', function (n) { return _this.getMonthTips(); }); //日历提醒
        return _this;
    }
    ;
    // 查看详情
    LeftMenuModel.prototype.checkTipInfo = function (d) {
        this.showTB(false);
        page('/home/tipsInfo?id=' + d.id);
    };
    LeftMenuModel.prototype.leftScroll = function () {
        this.showTB(false); //000
    };
    // 获取当天数据
    LeftMenuModel.prototype.getDayTips = function (nowDate) {
        // ajax.get('/api/message/day', { userId: authorization.getUserId(), day: nowDate }).then((d) => {
        //     this.nowDayTipList([]);
        //     if (d.status == '0') {
        //         this.nowDayTipList(d.data);
        //     }
        // })
        this.nowDayTipList([]);
        for (var i = 0; i < this.monthDataList().length; i++) {
            if (nowDate == this.monthDataList()[i].day) {
                this.nowDayTipList(this.monthDataList()[i].count);
            }
        }
    };
    // 获取当月数据
    LeftMenuModel.prototype.getMonthTips = function () {
        var _this = this;
        ajax.get('/api/message/monthpc', { userId: authorization.getUserId(), month: this.nowYear() + '-' + this.nowMonth() }).then(function (d) {
            _this.monthDataList(d.data);
            var se = _this.container.querySelectorAll('.current-month');
            for (var m = 0; m < se.length; m++) {
                for (var n = 0; n < d.data.length; n++) {
                    var ri = Number(se[m].children[0].innerHTML);
                    var bcDay = d.data[n].day.substring(8, 10);
                    if (ri < 10) {
                        ri = '0' + ri;
                    }
                    if (ri == bcDay) {
                        // se[m]
                        var spanObj = document.createElement('span');
                        spanObj.className = 'rili-span';
                        // for(let i=0;i<d.data[n].count;i++){
                        se[m].appendChild(spanObj);
                        // }
                    }
                }
            }
        });
    };
    LeftMenuModel.prototype.loadRili = function () {
        var myDate = new Date();
        var tYear = myDate.getFullYear();
        this.nowYear(tYear);
        var tMonth = myDate.getMonth() + 1;
        if (Number(tMonth) < 10) {
            tMonth = '0' + tMonth;
        }
        this.nowMonth(tMonth);
        var that = this;
        var mySchedule = new Schedule({
            el: "#schedule-box",
            changeMonth: function (y, m) {
                if (Number(m) < 10) {
                    m = '0' + m;
                }
                that.nowYear(y);
                that.nowMonth(m);
                that.getMonthTips();
                console.log('000000000000000切换', that.nowYear(), that.nowMonth());
            },
            // clickCb: function (y: any, m: any, d: any) {
            //     if (Number(d) < 10) {
            //         d = '0' + d;
            //     }
            //     if (Number(m) < 10) {
            //         m = '0' + m;
            //     }
            // },
            mouseoverCb: function (e) {
                if (e.target.className.indexOf('currentDate') > -1) {
                    var nd = e.target.innerHTML;
                    if (Number(e.target.innerHTML) < 10) {
                        nd = '0' + e.target.innerHTML;
                    }
                    var str = that.nowYear() + "-" + that.nowMonth() + "-" + nd;
                    var tk = that.container.querySelector('.leftMenu-nowDay-tips');
                    that.getDayTips(str);
                    // console.log(e.target.parentNode.offsetTop, e.target.parentNode.offsetLeft, e, '----offsetTop');
                    if (e.target.parentNode.offsetLeft > 95) {
                        tk.style.left = e.target.parentNode.offsetLeft - 80 + 'px';
                    }
                    else {
                        tk.style.left = e.target.parentNode.offsetLeft + 10 + 'px';
                    }
                    tk.style.top = e.target.parentNode.offsetTop + 30 + 'px';
                    if (that.nowDayTipList().length > 0) {
                        that.showTB(true);
                    }
                }
            },
            mouseoutCb: function (e) {
                // console.log(e);
                // that.showTB(false);
            }
        });
        this.getMonthTips();
    };
    // 
    LeftMenuModel.prototype.scheduleOut = function () {
        this.showTB(false); //9999
    };
    LeftMenuModel.prototype.loadbubble = function () {
        var _this = this;
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            _this.myProject(d.data.count0);
            _this.myFollowProject(d.data.count1);
            _this.noFollowNews(d.data.count2);
            _this.waitProjectNews(d.data.count3);
            _this.signgedProjectNews(d.data.count4);
            _this.abandonProjectNews(d.data.count5);
            _this.auditMessage(d.data.count6);
        });
    };
    LeftMenuModel.prototype.changeNum = function (num) {
        return (parseInt(num) / 10000).toFixed(2);
    };
    LeftMenuModel.prototype.loadnum = function () {
        var _this = this;
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: localStorage.getItem('7') }).then(function (d) {
            _this.allProject(d.data.allProject);
            _this.followProject(d.data.followProject);
            _this.nofollow(d.data.nofollow);
            _this.waitProject(d.data.waitProject);
            _this.signgedProject(d.data.signgedProject);
            _this.abandonProject(d.data.abandonProject);
            _this.noReadProject(d.data.noReadProject);
        });
    };
    LeftMenuModel.prototype.load = function () {
        var _this = this;
        this.username(authorization.getUsername());
        this.role(localStorage.getItem('role'));
        this.imgurl(localStorage.getItem('img'));
        this.data.uid = authorization.getUserId();
        // this.loadbubble();
        // this.loadnum();
        this.loadData().then(function (d) {
            _this.loadRili();
        });
    };
    LeftMenuModel.prototype.signOut = function () {
        window.popBox.show('确定退出么？', {
            isConfirmModal: true,
        }).then(function () {
            authorization.signOut();
        });
    };
    return LeftMenuModel;
}(KnockoutModel));
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        return _super.call(this, "leftmenu", html) || this;
    }
    MyComponent.prototype.init = function () {
        var _this = this;
        this.lm = new LeftMenuModel(this.container);
        // this.lm.bind();
        // ko.applyBindings(this, this.container.querySelector(".leftmenu-index"));
        ko.postbox.subscribe(Topics.app_account_login, function (n) {
            _this.lm.load();
        });
        if (authorization.isLogin()) {
            this.lm.load();
        }
        this.lm.showTB(false); //999
    };
    MyComponent.prototype.onInitComplete = function () {
        // console.log('000000000000000000000000000')
    };
    return MyComponent;
}(Component));
export { MyComponent };
export default new MyComponent();
